import * as React from "react";
import { CardTimeline } from "./components";
import { func } from "../../../utils";
import moment from "moment";

export interface CardTimelineProps {
  id: number;
  region_id: number;
  title: string;
  button_text: string;
  subtitle: string;
  icon: string;
  link: string;
  start_date: string;
  end_date: string;
  created_at: string;
  updated_at: string;
  status: number;
}

export interface Props {
  data: CardTimelineProps[];
  mode: "desktop" | "mobile";
}

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/timeline/`;

const CityTimeline: React.FC<Props> = ({ data = [], mode }) => {
  const checkIsPastDate = (endDate: string) => {
    const currentDate = moment();

    return moment(endDate)?.isAfter(currentDate, "date");
  };

  const generateDate = (startDate: string, endDate: string, withYears: boolean = false) => {
    const mStartDate = moment(startDate);
    const mEndDate = moment(endDate);

    const isSameMonth = mStartDate?.isSame(mEndDate, "month");
    const isSameYears = mStartDate?.isSame(mEndDate, "year");
    const isSameDay = mStartDate?.isSame(mEndDate, "day");

    console.log({ isSameDay, mStartDate, mEndDate });

    if (isSameMonth) {
      if (withYears) {
        if (isSameDay) {
          return mEndDate?.format("DD MMMM YYYY");
        }
        return `${mStartDate?.format("DD")} - ${mEndDate?.format("DD MMMM YYYY")}`;
      }

      if (isSameDay) {
        return mEndDate?.format("DD MMMM YYYY");
      }
      return `${mStartDate?.format("DD")} - ${mEndDate?.format("DD MMMM")}`;
    }

    if (withYears && isSameYears) {
      if (isSameYears) {
        return `${mStartDate?.format("DD MMMM")} - ${mEndDate?.format("DD MMMM YYYY")}`;
      }
    }

    if (withYears) {
      return `${mStartDate?.format("DD MMMM YYYY")} - ${mEndDate?.format("DD MMMM YYYY")}`;
    }

    return `${mStartDate?.format("DD MMMM")} - ${mEndDate?.format("DD MMMM")}`;
  };

  const generateLinePath = (index: number) => {
    const isFirstItem = index === 0;
    const isLastItem = index === data?.length - 1;

    if (isFirstItem) return <div className="absolute w-[50%] right-0 h-[1px] bg-white" />;
    if (isLastItem) return <div className="absolute w-[50%] left-0 h-[1px] bg-white" />;

    return <div className="absolute left-0 right-0 w-full h-[1px] bg-white" />;
  };

  const handleErrorImage = (event: React.ChangeEvent<HTMLImageElement>) => {
    event.target.onerror = null;
    event.target.src = func.getStaticImg("illustration/default-image.png");
  };

  if (mode === "mobile") {
    return (
      <div className="flex flex-col gap-x-[20px] items-center w-[100vw] px-[20px]">
        {data?.map((item, idx) => {
          const isFirstItem = idx === 0;
          /** Temp logic */
          const isActive = item?.status === 1;
          const isLastDay = idx === data?.length - 1;

          return (
            <div
              key={idx}
              style={{ marginTop: isFirstItem ? 20 : 0 }}
              className="flex gap-x-[16px] h-[max-content] w-[100%]  overflow-y-hidden"
            >
              <div className="flex flex-col items-center">
                {isActive ? (
                  <div className="h-[16px] w-[16px] rounded-full bg-white border-[2px] border-[#00BCF1] p-[2px] flex justify-center items-center">
                    <div className="bg-[#0397C9] w-[6px] h-[6px] rounded-full" />
                  </div>
                ) : (
                  <div className="h-[16px] w-[16px] rounded-full bg-white" />
                )}
                {!isLastDay && <div className="w-[1px] h-full bg-white relative" />}
              </div>
              <div className="flex flex-col gap-4 w-[100%]">
                <div className="flex justify-between items-center">
                  <p
                    className={
                      isActive
                        ? "text-[16px] leading-0 text-[#FFBC00] font-semibold"
                        : "leading-0 text-[14px] text-white"
                    }
                  >
                    {generateDate(item?.start_date, item?.end_date, true)}
                  </p>
                </div>
                <CardTimeline
                  key={idx}
                  icon={
                    <img
                      src={`${imgPath}${item?.icon}`}
                      width={30}
                      height={30}
                      alt="icon card timeline"
                      className={!isActive ? "filter grayscale" : ""}
                      onError={handleErrorImage}
                    />
                  }
                  title={item?.title}
                  subtitle={item?.subtitle}
                />
                <div className="h-[16px]" />
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex justify-center mt-[16px] w-[100%]">
      {/* temporary until have valid endpoint */}
      {data?.map((item, idx) => {
        const isActive = item?.status === 1;

        return (
          <div key={idx} className="flex flex-col">
            <div className="w-[250px] flex flex-col gap-y-[16px] items-center">
              <div className="h-[8px] w-full">
                <div className="flex relative items-center justify-center mb-[8px]">
                  {isActive ? (
                    <div className="relative z-10 h-[16px] w-[16px] rounded-full bg-white border-[2px] border-[#00BCF1] p-[2px] flex justify-center items-center">
                      <div className="bg-[#0397C9] w-[6px] h-[6px] rounded-full" />
                    </div>
                  ) : (
                    <div className="relative z-10 h-[16px] w-[16px] rounded-full bg-white" />
                  )}
                  {generateLinePath(idx)}
                </div>
              </div>
              <div className="flex flex-col">
                <div className="flex justify-between items-center">
                  <p
                    className={
                      isActive
                        ? "text-[16px] leading-0 text-[#FFBC00] font-semibold"
                        : "leading-0 text-[14px] text-white"
                    }
                  >
                    {generateDate(item?.start_date, item?.end_date, true)}
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex gap-y-[16px] flex-col">
                  <CardTimeline
                    key={idx}
                    icon={
                      <img
                        src={`${imgPath}${item?.icon}`}
                        width={30}
                        height={30}
                        alt="icon card timeline"
                        className={!isActive ? "filter grayscale" : ""}
                        onError={handleErrorImage}
                      />
                    }
                    title={item?.title}
                    subtitle={item?.subtitle}
                  />
                </div>
                <div className="w-[28px]" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CityTimeline;
